import {
  LegalClientSourcesOfIncomeFinancialSourceType,
  LegalClientSourcesOfIncomeSourceType,
} from 'api/types/entity';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  array,
  selectSchema,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import { SelectType } from 'types/selectType';

export interface SourcesOfIncomeFormType {
  incomeSources: SelectType<LegalClientSourcesOfIncomeSourceType>[];
  financialSources: SelectType<LegalClientSourcesOfIncomeFinancialSourceType>[];
  otherIncomeSource?: string;
  otherFinancialSource?: string;
  fileIds: string[];
}

export const MAX_FILES = 20;

const isOtherIncomeSource = (
  values: SelectType<LegalClientSourcesOfIncomeSourceType>[]
) =>
  values?.find(
    (v) => v?.value === LegalClientSourcesOfIncomeSourceType.Other
  ) !== undefined;

const isOtherFinancialSource = (
  values: SelectType<LegalClientSourcesOfIncomeFinancialSourceType>[]
) =>
  values?.find(
    (v) => v?.value === LegalClientSourcesOfIncomeFinancialSourceType.Other
  ) !== undefined;

export const getSchema = (t: TFunc): ObjectSchema<SourcesOfIncomeFormType> =>
  object({
    otherIncomeSource: string().when('incomeSources', {
      is: isOtherIncomeSource,
      then: (schema) => schema.required().max(200),
    }),
    otherFinancialSource: string().when('financialSources', {
      is: isOtherFinancialSource,
      then: (schema) => schema.required().max(200),
    }),

    incomeSources: array()
      .of(
        selectSchema(Object.values(LegalClientSourcesOfIncomeSourceType))
          .default(null)
          .required()
      )
      .min(1, t('validation.required'))
      .required(),

    financialSources: array()
      .of(
        selectSchema(
          Object.values(LegalClientSourcesOfIncomeFinancialSourceType)
        )
          .default(null)
          .required()
      )
      .min(1, t('validation.required'))
      .required(),

    fileIds: array().of(string().required()).required().min(1).max(MAX_FILES),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<SourcesOfIncomeFormType>();

export type FormErrors = FormErrorsBase<SourcesOfIncomeFormType>;
